import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { documentStatusStore } from '../../features/dashboard/DocumentStatusSlice';
import Header from './Header';
import Input from '../form/Input';
import Select from '../form/Select';
import Button from '../form/Button';
import Loading from '../../Loading';
import { ToastContainer, toast } from 'react-toastify';

function DocumentStatus () {

    const dispatch = useDispatch();
    const [status, setStatus] = useState(false)
    const [archive, setArchive] = useState('')
    const [title, setTitle] = useState('')
    const [loadingPage, setLoadingPage] = useState(true)
    let {
        loading,
        success,
        message,
        errorTitle,
    } = useSelector((state) => state.DocumentStatus)

    useEffect(() => {
        // Handle Loading page Before Load DOM
        status === true ? setLoadingPage(true) : setLoadingPage(false)
        if(success === true && status === true) {
            toast.success(message,{
                position: "top-center",
                autoClose: 600,
              })
            setStatus(false)
            setLoadingPage(false)
            setTitle('')
            setArchive('')
            message = ''
        }

        return () => {
            // Handle Loading page Before Load DOM
            // setLoading(archiveSectionOneSuccess)
        }

    },[success])

    const documentStatusStoreHandler = (event) => {
        event.preventDefault();
        setLoadingPage(true)
        setStatus(true)
        const data = {
            'title': title
        }
        dispatch(documentStatusStore(data));
    }
    return (
        <>
        { loading ? (<Loading />) : null }
        <form className="text-end">
            <div className='row g-2 p-5 my-5'>
                <Header title={'ایجاد وضعیت سند'} />  
                <div className="col-6 ">
                    <Input 
                        key='1'
                        tab='1'
                        col='col-12'
                        type='text'
                        maxlength={255}
                        name='number'
                        value={title}
                        title='انتخاب نام وضعیت سند'
                        onchange={(e) => setTitle(e.target.value)}
                        placeholder='مانند : ارسال به راهور' 
                        errorName={errorTitle}
                    />   
                </div>
                <div className="row g-2 px-0 mt-4 mb-0">
                    <div className="row mx-1 d-grid gap-2 col-6 col-md-3 me-auto">
                        <Button 
                            tab='2'
                            title=' ثبت '
                            design="position-relative px-4 py-1 btn btn-dark fw-bold"
                            event={documentStatusStoreHandler}
                        />
                    </div>
                </div>
            </div>
        </form>
        </>
    )
}

export default DocumentStatus;